import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { getButtonStyleClass, BUTTON_CLASS, ButtonVariant } from './utils';
export interface ButtonProps {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  variant?: ButtonVariant;
  dataTestId?: string;
  children?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  name?: string;
  value?: string | number | readonly string[];
  id?: string;
  tabIndex?: number;
  form?: string;
  stopPropagation?: boolean;
}

const Button: FC<ButtonProps> = ({
  onClick,
  className,
  disabled = false,
  variant = ButtonVariant.Primary,
  dataTestId = 'button',
  children,
  type = 'button',
  name,
  value,
  id,
  tabIndex,
  form,
  stopPropagation = false,
}) => {
  const buttonStyleClass = getButtonStyleClass(variant, disabled);

  return (
    <button
      tabIndex={tabIndex}
      id={id}
      value={value}
      name={name}
      type={type}
      disabled={disabled}
      data-testid={dataTestId}
      className={twMerge(BUTTON_CLASS.BASE, buttonStyleClass, className)}
      onClick={event => {
        stopPropagation && event.stopPropagation();
        onClick?.();
      }}
      form={form}
    >
      {children}
    </button>
  );
};

export default Button;
export { ButtonVariant };
